/**
 * Returns true when the turn has not yet settled to a terminal state.
 * Exhaustive switch ensures new ChatStatus values require an explicit decision here.
 */
export function isTurnInProgress(status) {
  switch (status) {
    case 'READY':
    case 'ERROR':
      return false;
    case 'LOADING':
    case 'STREAMING':
    case 'CANCELLING':
    case 'AWAITING_TOOL':
    case 'AWAITING_APPROVAL':
      return true;
    default:
      {
        const __exhaustive = status;
        return false;
      }
  }
}